export function formatUsd(value: number | null | undefined): string {
  if (value === null || value === undefined || !Number.isFinite(value)) return "—";
  return value.toLocaleString(undefined, { style: "currency", currency: "USD" });
}

/** Margin denominator 0.70 → "30%". */
export function formatMarginFromDenom(denom: number | null | undefined): string {
  if (denom === null || denom === undefined || !Number.isFinite(denom) || denom <= 0 || denom > 1) {
    return "—";
  }
  const pct = (1 - denom) * 100;
  return `${pct.toFixed(1)}%`;
}

export function marginPctToDenom(pct: number): number | null {
  if (!Number.isFinite(pct) || pct < 0 || pct >= 100) return null;
  return Number((1 - pct / 100).toFixed(6));
}

export function denomToMarginPctInput(denom: number | null | undefined): string {
  if (denom === null || denom === undefined || !Number.isFinite(denom) || denom <= 0 || denom > 1) {
    return "";
  }
  return String(Number(((1 - denom) * 100).toFixed(2)));
}
